import {Component, Input, OnInit} from '@angular/core';
import {ExcRestService} from 'exc-rest-v2';
import {ApplicationService} from '../../../services/application.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../../services/enumeration.service';

@Component({
  selector: 'app-modal-file-pdf-editor',
  templateUrl: './modal-file-pdf-editor.component.html',
  styles: [
  ]
})
export class ModalFilePdfEditorComponent extends ExcTranslation implements OnInit {
  vorgOrAuNr = '';
  entity = '';
  selectedTask: any;
  get uiSaveInCase(): boolean {
    return this._uiSaveInCase;
  }
  set uiSaveInCase(value: boolean) {
    if (!this.uiSaveInCaseDisabled) {
      this._uiSaveInCase = value;
      if (value) {
        this.selectedTask = undefined;
      }
    }
    else {
      this.modalService.showToast(this.getRessource('NoTasks'), 'md-toast', 'fas fa-exclamation');
    }
  }
  @Input()
  set data(value: any) {
    if (value) {
      this._data = value;
    }
  }
  get data(): any {
    return this._data;
  }
  private _data: any = {};

  init = true;
  answers: {[placeholder: string]: any} = {};
  answersLength = 0;
  filename = '';
  nummerTyp = '';
  schadennummer = '';
  dokQuellNr = '';

  uiSelectDocumentTypeIndex = 0;
  // tslint:disable-next-line:variable-name
  dok_enmIdent_DokTyp = 1;
  initialFilename = '';

  documentPDF = {
    isLoading: false,
    docPDF: {} as any,
    loadData: () => {
      const SELF = this;
      SELF.documentPDF.isLoading = true;

      SELF.excRestService
        .get(
          SELF.excRestService.computeUrl('DocumentR', {
            dokID: this.data.dokID
          }), { })
        .subscribe(
          (data: any) => {
            if (data.success) {
              SELF.documentPDF.docPDF = data.data;
              if (SELF.documentPDF.docPDF.dok_enmIdent_DokTyp) {
                SELF.setDocumentType(SELF.documentPDF.docPDF.dok_enmIdent_DokTyp, true);
              }
              if (this.data && this.data.selectedSummary) {
                this.checkIfTaskOrCase(this.data.selectedSummary.taskList.data, this.data.selectedSummary);
              }
            }
            if (SELF.init) {
              SELF.init = false;
            }
            SELF.documentPDF.isLoading = false;
          }
        );
    },
  };
  private _uiSaveInCase = false;
  uiSaveInCaseDisabled = false;
  uiSelectTaskIndex = 0;
  uiTaskList: any[] = [];

  constructor(
    public excRestService: ExcRestService,
    public appSvc: ApplicationService,
    public excSecurity: ExcSecurityService,
    private modalService: ExgModalService,
    public enumSvc: EnumerationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.registerEvents();
    const dokTypList = this.enumSvc.getEnumerationList('DokTyp');
    const preSelectedIndex = dokTypList.findIndex(e => e.enmDefault);
    this.setDocumentType(preSelectedIndex >= 0 ? preSelectedIndex : 0);

    this.documentPDF.loadData();
  }

  isFilenameModified(): boolean {
    return this.filename !== this.initialFilename && this.filename.length > 0;
  }

  private checkIfTaskOrCase(taskList: any[], summary: any): void {
    let filenameSuffix;
    const index = taskList.findIndex((task: any) => task.vorgID === this.data.objID);
    if (index > -1) {
      this.entity = 'task';
      this.vorgOrAuNr = taskList[index].vorgNr;
      this.chooseOwnTaskNumber(summary, taskList);
      this.nummerTyp = summary.caseDetails.data.aueSchadenNr ?
        this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')
        : this.enumSvc.getFieldCaption('Vorgang', 'vorgNr');
      filenameSuffix =  summary.caseDetails.data.aueSchadenNr ?  summary.caseDetails.data.aueSchadenNr : taskList[index].vorgNr;
    } else {
      this.entity = 'case';
      this.vorgOrAuNr = summary.caseDetails.data.auNr;
      this.nummerTyp = summary.caseDetails.data.aueSchadenNr ?
        this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')
        : this.enumSvc.getFieldCaption('Vorgang', 'auNr');
      filenameSuffix =  summary.caseDetails.data.aueSchadenNr ?  summary.caseDetails.data.aueSchadenNr : summary.caseDetails.data.auNr;
    }
    if (filenameSuffix) {
      this.filename = '_' + filenameSuffix;
      this.initialFilename = this.filename;
    }


    /*Check if TaskList Disabled*/
    if (taskList) {
      if (taskList?.length > 0) {
        this.uiTaskList = taskList;
        this.uiSaveInCaseDisabled = false;
      }
      else {
        this._uiSaveInCase = true;
        this.uiSaveInCaseDisabled = true;
      }
    }
  }

  setDocumentType(ident: number, test: boolean = false): void {
    const dokTypList = this.enumSvc.getEnumerationList('DokTyp');

    if (test) {
      const index = dokTypList.findIndex(e => e.enmIdent === ident);
      this.uiSelectDocumentTypeIndex = index >= 0 ? index : 0;
      this.dok_enmIdent_DokTyp = ident;
    } else {
      if (ident >= 0 && ident < dokTypList.length) {
        this.uiSelectDocumentTypeIndex = ident;
        this.dok_enmIdent_DokTyp = dokTypList[ident].enmIdent;
      }

    }
  }
  registerEvents(): void {

  }

  selection(dokID: any, event: boolean): void {
    this.answers[dokID] = event;
    this.answersLength = 0;
    for (const key of Object.keys(this.answers)) {
      if (this.answers[key]) {
        this.answersLength++;
      }
    }
  }

  generatePageNumbers(dokPages: number): number[] {
    const pageNumbers: number[] = [];
    for (let i = 1; i <= dokPages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  }

  save(): void {
    if (this.isFilenameModified()) {
      let pages = '';

      for (const key of Object.keys(this.answers)) {
        if (this.answers[key]) {
          pages += key + ';';
        }
      }
      let ID = '';
      if (this.uiSaveInCase && this.entity === 'case') {
        ID = this.data.objID;
      }
      else if (this.uiSaveInCase && this.entity === 'task') {
        ID = this.data.selectedSummary.caseDetails.data.auID;
      }
      else if (!this.uiSaveInCase && this.selectedTask) {
        ID = this.selectedTask.vorgID;
      }

      this.excRestService.post(
        this.excRestService.computeUrl('PDFSplit', {
          dokID: this.documentPDF.docPDF.dokID
        }), {
          filename: this.filename,
          selectedPages: pages.slice(0, -1),
          dok_objID: ID,
          dok_enmIdent_DokTyp: this.dok_enmIdent_DokTyp
        }
      ).subscribe((rtValue: any) => {
        if (rtValue && rtValue.success) {
          this.modalService
            .showToast(this.getRessource('FileWasSaved')
              , 'md-toast bg-green'
              , 'far fa-file-image');
          this.data.Events.Document?.UpdateDialog?.Closed.emit();
          this.answers = {};
          this.answersLength = 0;
          this.filename = this.initialFilename;
        }
      });
    }
  }

  close(): void {
    this.modalService.close();
  }

  setSelectedTask(index: any): void {
    this.selectedTask = this.uiTaskList[index];
  }

  chooseOwnTaskNumber(summary: any, taskList: any): void {
    const ID = this.data.objID;
    const index = taskList.findIndex((task: any) => task.vorgID === ID);
    if (index > -1) {
      this.uiSelectTaskIndex = index;
      this.selectedTask = taskList[index];
    }
  }
}
